/* ═══════════════════════════════════════════════════════════════════════════
   KLADIORA — Aion X açılış sayfası için hamburger menü (header drawer).
   Kaynak: canlı Shopify temasının global.js dosyası (Dawn header-drawer).
   Buraya BİREBİR alındı; yalnızca standalone çalışması için gereken küçük
   uyarlamalar yapıldı (bkz. HeaderDrawer.getHeaderEl).
   Custom element'ler kasıtlı olarak <kla-menu-drawer>/<kla-header-drawer> diye
   ADLANDIRILDI: canlı temanın <header-drawer>/<menu-drawer> tanımları ve
   "header-drawer svg{...!important}" gibi kuralları benim elementlerime ÇARPMAZ.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Dawn, JS varken bazı stilleri açmak için <html class="js"> ekler.
  document.documentElement.classList.add('js');

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  var trapFocusHandlers = {};

  function trapFocus(container, elementToFocus) {
    elementToFocus = elementToFocus || container;
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (event.target === container || event.target === last || event.target === first) {
        document.addEventListener('keydown', trapFocusHandlers.keydown);
      }
    };
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus();

    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

  function removeTrapFocus(elementToFocus) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
  }

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach(function (summary) {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      }, this);
      this.querySelectorAll(
        'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
      ).forEach(function (button) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }, this);
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      var openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
      var summaryElement = event.currentTarget;
      var detailsElement = summaryElement.parentNode;
      var parentMenuElement = detailsElement.closest('.has-submenu');
      var isOpen = detailsElement.hasAttribute('open');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }

      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        if (window.matchMedia('(max-width: 990px)').matches) {
          document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
        }
      } else {
        setTimeout(function () {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }

    openMenuDrawer(summaryElement) {
      setTimeout(function () {
        this.mainDetailsToggle.classList.add('menu-opening');
      }.bind(this));
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add('overflow-hidden-' + this.dataset.breakpoint);
    }

    closeMenuDrawer(event, elementToFocus) {
      if (event === undefined) return;
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(function (submenu) {
        submenu.classList.remove('submenu-open');
      });
      // KLADIORA accordion (DİĞER HİZMETLER) — menü kapanınca kapalıya döndür
      this.mainDetailsToggle.querySelectorAll('.kla-submenu.open').forEach(function (w) {
        w.classList.remove('open');
        var t = w.querySelector('.kla-submenu-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('overflow-hidden-' + this.dataset.breakpoint);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (event instanceof KeyboardEvent && elementToFocus) {
        elementToFocus.setAttribute('aria-expanded', false);
      }
    }

    onFocusOut() {
      setTimeout(function () {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
          this.closeMenuDrawer();
        }
      }.bind(this));
    }

    onCloseButtonClick(event) {
      var details = event.currentTarget.closest('details');
      this.closeSubmenu(details);
    }

    closeSubmenu(detailsElement) {
      var parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      var animationStart;
      var handleAnimation = function (time) {
        if (animationStart === undefined) animationStart = time;
        if (time - animationStart < 400) {
          window.requestAnimationFrame(handleAnimation);
          return;
        }
        detailsElement.removeAttribute('open');
        var parentDetails = detailsElement.closest('details[open]');
        if (parentDetails) {
          trapFocus(parentDetails, detailsElement.querySelector('summary'));
        }
      };
      window.requestAnimationFrame(handleAnimation);
    }
  }

  if (!customElements.get('kla-menu-drawer')) customElements.define('kla-menu-drawer', MenuDrawer);

  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }

    // STANDALONE UYARLAMASI: header olarak KENDİ .kla-ham sarmalayıcımızı alırız.
    // Canlı temanın .section-header'ını ARAMAYIZ; yoksa menü, tema header'ının
    // altına konumlanır ve temanın header'ına "menu-open" eklerdik.
    getHeaderEl() {
      return this.closest('.kla-ham') || this;
    }

    openMenuDrawer(summaryElement) {
      this.header = this.header || this.getHeaderEl();
      this.borderOffset = 0; // .kla-ham'in alt kenarlığı yok
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset) + 'px'
      );
      this.header.classList.add('menu-open');

      setTimeout(function () {
        this.mainDetailsToggle.classList.add('menu-opening');
      }.bind(this));

      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add('overflow-hidden-' + this.dataset.breakpoint);
    }

    closeMenuDrawer(event, elementToFocus) {
      if (!elementToFocus) return;
      super.closeMenuDrawer(event, elementToFocus);
      this.header && this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }

    onResize = function () {
      if (this.header) {
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset) + 'px'
        );
      }
      document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    }.bind(this);
  }

  if (!customElements.get('kla-header-drawer')) customElements.define('kla-header-drawer', HeaderDrawer);

  // ── KLADIORA accordion — "DİĞER HİZMETLER ▼" aç/kapa (Dawn slide-panel'i
  //    yerine gerçek aşağı-açılır). <div role=button> olduğu için MenuDrawer'ın
  //    summary/button dinleyicilerine takılmaz; burada delege ile yönetilir. ──
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.kla-submenu-toggle');
    if (!toggle) return;
    var wrap = toggle.closest('.kla-submenu');
    if (!wrap) return;
    var open = wrap.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.code !== 'Space') return;
    var toggle = e.target.closest && e.target.closest('.kla-submenu-toggle');
    if (!toggle) return;
    e.preventDefault();
    toggle.click();
  });
})();
